import { render, staticRenderFns } from "./VoteResponseTicket.vue?vue&type=template&id=5a219134&"
import script from "./VoteResponseTicket.vue?vue&type=script&lang=js&"
export * from "./VoteResponseTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports